import { z } from 'zod';

export const WorkOrderScalarFieldEnumSchema = z.enum(['caseId','cityId','workOrderSite','workOrderChargeAcct','workOrderJobType','workOrderCategory','totalMaterialCost','totalLaborCost','totalCost']);

export default WorkOrderScalarFieldEnumSchema;
